/**
 * NotificationToggleRow
 *
 * Eine Zeile innerhalb einer ProfileSection für Benachrichtigungs-Toggles.
 *
 * Layout:
 *   ┌──────────────────────────────────────────────────────────┐
 *   │ [icon] Titel der Sub-Sektion                  [Toggle]   │
 *   │                                                          │
 *   │ Beschreibung über volle Breite, kein Quetschen mehr      │
 *   │ zwischen Icon und Toggle.                                │
 *   │                                                          │
 *   │ Optional: zusätzlicher Inhalt (z.B. Geräte-Status)       │
 *   └──────────────────────────────────────────────────────────┘
 */

import React from 'react';

interface NotificationToggleRowProps {
  icon: React.ReactNode;
  title: string;
  description: React.ReactNode;
  control?: React.ReactNode;
  /** Optionaler Block unterhalb der Beschreibung, eingerückt unter dem Icon */
  children?: React.ReactNode;
}

export const NotificationToggleRow: React.FC<NotificationToggleRowProps> = ({
  icon,
  title,
  description,
  control,
  children,
}) => (
  <div className="py-3">
    {/* Layout: [Icon] | [Titel über Beschreibung] | [Toggle vertikal mittig].
        Drei Spalten als Flex-Container, Toggle sitzt ganz rechts im
        verfügbaren Container, vertikal mittig zum Text-Block. */}
    <div className="flex items-center gap-4">
      <div className="shrink-0 w-9 h-9 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center">
        {icon}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-900 dark:text-white">
          {title}
        </p>
        <div className="mt-1 max-w-xl text-xs text-gray-500 dark:text-gray-400 leading-relaxed">
          {description}
        </div>
      </div>
      {control && <div className="shrink-0">{control}</div>}
    </div>

    {children && <div className="mt-3 ml-13 pl-0">{children}</div>}
  </div>
);

export default NotificationToggleRow;
